import useSWRImmutable from "swr/immutable";
import { getData } from "../backend";
import { HubspotObject } from "../interfaces";

interface Args {
  primaryObjectTypeId: string;
  search: string;
  properties?: Array<string>;
  associations?: Array<string>;
  after?: number;
  limit?: number;
  sortingField?: string;
  sortingDirection?: "ASC" | "DSC";
}

export default function useHubspotSearch(args: Args) {
  let url = `/hubspot/objects/${args.primaryObjectTypeId}?search=${args.search}`;

  if (args.properties)
    url += `&properties=${args.properties.join(",")}`;

  if (args.associations)
    url += `&associations=${args.associations.join(",")}`;

  if (args.after)
    url += `&after=${args.after}`;

  if (args.limit)
    url += `&limit=${args.limit}`;

  if (args.sortingField)
    url += `&sorting=${args.sortingDirection === "DSC" ? "-" : ""}${args.sortingField}`;

  return useSWRImmutable<{ results: Array<HubspotObject>, paging: { next: string }, total: number }>(url, getData);
}

